<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 参展人员卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <span style="font-weight: bold">参展人员</span>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table
          :data="tableData"
          style="width: 100%;">
          <el-table-column type="index" label="编号" prop="id"></el-table-column>
          <el-table-column
            prop="wx_user_detail.avatarurl"
            label="微信头像"
          >
            <template slot-scope="scope">

              <el-image :src="logourl + scope.row.wx_user_detail.avatarurl" style="width:30px">
                <div slot="error">
                  <i class="el-icon-picture-outline" style="font-size: 30px"></i>
                </div>
              </el-image>

            </template>

          </el-table-column>
          <el-table-column
            prop="position"
            label="名字"
          >
          </el-table-column>
          <el-table-column
            prop="phone_number"
            label="手机号">
          </el-table-column>

          <el-table-column
            prop="name"
            label="职务"
          >
          </el-table-column>

          <el-table-column
            prop="user_detail.name"
            label="公司名"
          >
          </el-table-column>
          <el-table-column
            prop="user_detail.booth"
            label="展位号"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="加入时间"
          >
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="deleteClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {

    data() {
      return {
        tableData: [],
        logourl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      }
    },
    mounted() {
      this.hitListData()
    },
    methods: {
      /** 获取参展人员列表 */
      hitListData() {
        let userid = localStorage.getItem("userid");
        let url = this.baseUrl + "/user/exhibitors/?user=" + userid;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },
      /** 分页切换 */
      handleCurrentChange(val) {
        let userid = localStorage.getItem("userid");
        let url = this.baseUrl + "/user/exhibitors/?user=" + userid + "&page=" + val;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },


      /** 删除参展人员 */
      deleteClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/user/exhibitors/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.hitListData()
          });
        });
      },
    },


  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/ex_user.vue